<ion-card class="card-shadow-7"
                    style="border-radius: 0.5em;height: 100%;"
                   >
                   
                   <ion-grid class="ion-no-padding" style="color: black;">
                    <ion-row  >
                      <ion-col style="padding: 0.4em;">
                        <ion-label class="card-header-unique"> {{locker['AreaDescr']}}</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col style="padding: 0.5em;">
                        <ion-label class="card-header-unique">#{{locker['LockerNum']}}</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col class="ion-no-padding">
                       <h1  class="paragraph-bold"> <ion-icon
                        style="vertical-align: middle; font-size: x-large;"
                        name="location-outline"
                      ></ion-icon
                      >{{locker['Location']}}</h1>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col>
                        <ion-item lines="none">
                        <ion-label class="ion-text-wrap paragraph-regular">
                          {{locker['SemTitle']}} <br>{{locker['SemStart']| date:dataService.settings['system']['datemask']}} - {{locker['SemEnd'] | date:dataService.settings['system']['datemask']}}

                        </ion-label>
                        <span  style="text-align: right;" class="ion-text-wrap paragraph-bold">
                          {{locker['amount'] | currency}}
                        </span>
                      </ion-item>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col style="text-align: center;padding-bottom: 0.3em;">
                        <ion-chip *ngIf="locker['condition_name']" style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;
                        "  >{{ ('keys.data.lockers.condition' | translate) ||
                          'Condition' }}: {{locker['condition_name']}}</ion-chip>
                      </ion-col>
                    </ion-row>
                   </ion-grid>
                  
                     </ion-card>